import React from "react";
import styles from "./smartFilterPill.module.scss";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import useSmartFilter from "../useSmartFilter";
import wrapperHOC from "@Utils/wrapperHOC";
import { SmartFilterLogo } from "../icons";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import { PAGE } from "constants/configConstants";
import useTranslationHook from "hooks/useTranslationHook";

/**
 * The "Smart Filters" pill shown as the first item in the filter bar.
 * Clicking it opens the NLP search input panel.
 */
const SmartFilterPill: React.FC = () => {
  const { togglePanel, isOpen, appliedFilters } = useSmartFilter();
  const { t } = useTranslationHook();
  const hasAppliedFilters = appliedFilters && Object.keys(appliedFilters).length > 0;

  const handleClick = () => {
    togglePanel();
    if (!isOpen) {
      gtagEventEmitter({ action: "smart_filter_opened", category: PAGE.SEARCH });
    }
  };

  return (
    <button
      type="button"
      className={formatClassNames(
        styles.pill,
        isOpen && styles.active,
        hasAppliedFilters && styles.applied,
      )}
      onClick={handleClick}
      aria-label={t("searchpage.components.smartfilters.aria_smart_filters")}
      aria-expanded={isOpen}
    >
      <span className={styles.icon}>
        <SmartFilterLogo id="sfPillIconBlur" />
      </span>
      <span className={styles.label}>{t("searchpage.components.smartfilters.label")}</span>
    </button>
  );
};

export default wrapperHOC(SmartFilterPill, {
  componentName: "SmartFilterPill",
  showForChina: false,
  showForWhiteLable: true,
});
